import React from 'react';
import styles from './styles.module.scss';
import bgVesting from 'assets/img/bg_vesting_safe.png';
import safeImg from 'assets/img/safe.png';
import VestingSafeModalProvider from './VestingSafeModalProvider';
import MainContent from './Components/MainContent';
import BreakpointContent from '../Components/BreakpointContent';
import UserWalletProvider from '@profile/src/Profile_V2/UserWalletProvider';

const VestingSafe = () => {
  const renderDesktopTablet = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.root
    }, /*#__PURE__*/React.createElement("img", {
      className: styles.rootBg,
      src: bgVesting,
      alt: ""
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.title
    }, /*#__PURE__*/React.createElement("span", null, "Vesting Safe")), /*#__PURE__*/React.createElement("div", {
      className: styles.bodyDesktop
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.safeImg
    }, /*#__PURE__*/React.createElement("img", {
      src: safeImg,
      alt: ""
    })), /*#__PURE__*/React.createElement(MainContent, null))));
  };

  const renderMobile = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.root
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.title
    }, /*#__PURE__*/React.createElement("span", null, "Vesting Safe")), /*#__PURE__*/React.createElement("div", {
      className: styles.bodyMobile
    }, /*#__PURE__*/React.createElement(MainContent, null), /*#__PURE__*/React.createElement("div", {
      className: styles.safeImg
    }, /*#__PURE__*/React.createElement("img", {
      src: safeImg,
      alt: ""
    })))));
  };

  return /*#__PURE__*/React.createElement(UserWalletProvider, null, /*#__PURE__*/React.createElement(VestingSafeModalProvider, null, /*#__PURE__*/React.createElement(BreakpointContent, {
    renderDesktop: renderDesktopTablet,
    renderTablet: renderDesktopTablet,
    renderPhone: renderMobile
  })));
};

export default VestingSafe;